import {
  AvatarIcon,
  ErrorListItem,
  ListItemAvatar,
  ListItemButtonLink,
  ListItemText,
  Skeleton,
} from '@razz-team/ui-web';
import { ApiDigitalWalletToken } from '../../openapi';
import { DigitalWalletTokenRequestorIcon } from './DigitalWalletTokenRequestorIcon';
import { useCardQuery } from '../../api/cards';
import { useWalletName } from './useWalletName';

export function DigitalWalletTokenListItem({ token }: { token: ApiDigitalWalletToken }) {
  const cardQuery = useCardQuery({
    cardId: token.cardId,
  });

  const walletName = useWalletName(token);

  if (cardQuery.isError) {
    return <ErrorListItem error={cardQuery.error} />;
  }

  return (
    <ListItemButtonLink to="/account/dwt/$tokenId" params={{ tokenId: token.id }}>
      <ListItemAvatar>
        <AvatarIcon
          icon={<DigitalWalletTokenRequestorIcon tokenRequestor={token.tokenRequestor} />}
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          cardQuery.isSuccess ? (
            `${cardQuery.data.cardHolderName} · ••${cardQuery.data.lastFour}`
          ) : (
            <Skeleton variant="text" width={100} />
          )
        }
        secondary={`${walletName} · ${token.deviceName}`}
      />
    </ListItemButtonLink>
  );
}
